import { type BusinessErrorContext, type HttpErrorContext, WegicRequest } from '@wegic/request';
import { Message } from '@wegic/ui'
import '@wegic/ui/dist/components/Message/index.css';;
import { handlePermissionError } from '@/modules/CustomRouter/handler';
import { useUserStore } from '@/stores/user';
import { getAgentsAPIUrl, getAssetsAPIUrl, getErrorMessage, getRequestAPIUrl, getUserAPIUrl, getUserAPIUrlV2 } from './helper';

const baseConfig = {
  withCredentials: true,
  errorHandler: {
    onPermissionError: handlePermissionError,
    onHttpError: (context: HttpErrorContext) => {
      if (context.config?.hideHTTPErrorMessage) {
        return;
      }

      const message = context.key ? getErrorMessage(context.key) : context.message;
      message && Message.error(message);
    },
    onBusinessError: (context: BusinessErrorContext) => {
      if (context.config.hideCodeErrorMessage || useUserStore.getState().isLogin === false) {
        return;
      }

      const message = context.key ? getErrorMessage(context.key) : context.message;
      message && Message.error(message);
    },
  },
};

export const onePageRequest = WegicRequest({
  baseURL: getRequestAPIUrl(),
  ...baseConfig,
});

export const userRequest = WegicRequest({
  baseURL: getUserAPIUrl(),
  hideCodeErrorMessage: false,
  hideHTTPErrorMessage: false,
  ...baseConfig,
});

export const userRequestV2 = WegicRequest({
  baseURL: getUserAPIUrlV2(),
  hideCodeErrorMessage: false,
  hideHTTPErrorMessage: false,
  ...baseConfig,
});

export const agentsRequest = WegicRequest({
  baseURL: getAgentsAPIUrl(),
  hideCodeErrorMessage: false,
  hideHTTPErrorMessage: false,
  ...baseConfig,
});

export const tourRequest = WegicRequest({
  baseURL: getAgentsAPIUrl(),
  hideCodeErrorMessage: true,
  hideHTTPErrorMessage: true,
  ...baseConfig,
});

export const assetsRequest = WegicRequest({
  baseURL: getAssetsAPIUrl(),
  hideCodeErrorMessage: false,
  hideHTTPErrorMessage: false,
  ...baseConfig,
});
